module.exports={"(optional)":"(valfritt)","(required)":"(krävs)"};